import { z } from "zod";
const topicIdSchema = z.uuid().brand();
function asTopicId(id) {
  return topicIdSchema.parse(id);
}
const topicPayloadSchema = z.object({
  name: z.string().min(1).max(200),
  description: z.string().min(1).max(5e3),
  parentId: topicIdSchema.nullable().default(null)
});
const editableTopicNodeSchema = z.lazy(
  () => z.object({
    id: topicIdSchema.optional(),
    name: z.string().trim().min(1).max(200),
    description: z.string().trim().min(1).max(5e3),
    children: z.array(editableTopicNodeSchema).optional()
  })
);
const editableTopicNodesArraySchema = z.array(editableTopicNodeSchema);
const topicAnalysisPeriodCadenceSchema = z.enum(["weekly"]);
const topicAnalysisRecommendationSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("refine"),
    summary: z.string(),
    editorPrompt: z.string().min(1).max(2e3),
    criterionId: z.uuid().optional()
  }),
  z.object({
    kind: z.literal("alreadyCovered"),
    summary: z.string(),
    criterionId: z.uuid()
  }),
  z.object({
    kind: z.literal("noSignal"),
    summary: z.string()
  })
]);
const topicAnalysisOutputSchema = z.object({
  statsSummary: z.string().min(20).max(400),
  evidenceSummary: z.string().min(20).max(400),
  recommendation: topicAnalysisRecommendationSchema
});
export {
  asTopicId,
  editableTopicNodeSchema,
  editableTopicNodesArraySchema,
  topicAnalysisOutputSchema,
  topicAnalysisPeriodCadenceSchema,
  topicAnalysisRecommendationSchema,
  topicIdSchema,
  topicPayloadSchema
};
//# sourceMappingURL=topic.js.map
